import { FC, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import __ from "src/utils/Translations";
import Spinner from "src/Components/Spinner";

import { useFetchSubscription } from "./query";
import SubscriptionBenefitsDetails from "./SubscriptionBenefitsDetails";
import SubscriptionBenefitsPaymentsPeriods from "./SubscriptionBenefitsPaymentsPeriods";

interface Props {
  subscriptionId: string;
}

const SubscriptionBenefitsPreview: FC<Props> = ({ subscriptionId }) => {
  const [previewItemId, setPreviewItemId] = useState("");
  const [open, setOpen] = useState(false);

  const previewItem = () => {
    setPreviewItemId(subscriptionId);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPreviewItemId("");
  };

  const {
    data: details,
    isLoading,
    isSuccess,

    isError,
    error,
  } = useFetchSubscription(previewItemId);

  return (
    <>
      <GridActionsCellItem
        icon={<PreviewIcon />}
        onClick={previewItem}
        label={__("Podgląd")}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        scroll="paper"
        maxWidth={false}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "80vw",
            padding: 2,
            borderRadius: 2,
            boxSizing: "border-box",
          },
        }}
      >
        <DialogTitle sx={{ mt: 2, mb: 2 }}>
          {__("Szczegóły świadczenia")} {subscriptionId}
        </DialogTitle>
        <DialogContent>
          {isError && (
            <Alert variant="outlined" color="warning">
              {String(error)}
            </Alert>
          )}
          {isLoading && (
            <Stack
              sx={{ height: 280 }}
              direction="row"
              alignItems="center"
              justifyContent="center"
            >
              {Spinner}
            </Stack>
          )}
          {isSuccess && (
            <SubscriptionBenefitsDetails details={details}>
              <SubscriptionBenefitsPaymentsPeriods
                subscriptionId={subscriptionId}
              />
            </SubscriptionBenefitsDetails>
          )}
        </DialogContent>
        <DialogActions disableSpacing>
          <Button onClick={handleClose}>{__("Zamknij")}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubscriptionBenefitsPreview;
